import { Injectable } from "@angular/core";
import { AuthorizationCodeRequestBodyFactoryService } from "./authorization-code-request-body-factory.service";
import { AuthorizationCodeRequestConfigurationService } from "../../configuration/auth/authorization-code-request-configuration/authorization-code-request-configuration.service";
import { AuthorizationCodeRequestHeadersFactoryService } from "./authorization-code-request-headers-factory.service";
import { AuthModule } from "../auth.module";
import { AuthorityConfigurationService } from "../../configuration/auth/authority/authority-configuration.service";

@Injectable({
  providedIn: AuthModule,
})
export class AuthorizationCodeRequestService {
  get authorizationCodeRequestConfiguration() {
    return this.authorizationCodeRequestConfigurationService.configuration;
  }

  get grant_type() {
    return "authorization_code";
  }

  get redirect_uri() {
    return this.authorizationCodeRequestConfiguration.redirect_uri;
  }

  get path() {
    return this.authorizationCodeRequestConfiguration.path;
  }

  get addSuperBatmanHeader() {
    const authorityConfiguration = this.getLocalAuthorityConfiguration();
    if (authorityConfiguration) {
      return authorityConfiguration.addSuperBatmanHeader;
    } else {
      return false;
    }
  }

  constructor(
    private authorizationCodeRequestBodyFactoryService: AuthorizationCodeRequestBodyFactoryService,
    private authorizationCodeRequestConfigurationService: AuthorizationCodeRequestConfigurationService,
    private authorizationCodeRequestHeadersFactoryService: AuthorizationCodeRequestHeadersFactoryService,
    private authorityConfigurationService: AuthorityConfigurationService
  ) {}

  getLocalAuthorityConfiguration() {
    return this.authorityConfigurationService.getLocalConfiguration();
  }

  createBody(code) {
    return this.authorizationCodeRequestBodyFactoryService.createBody(code);
  }

  createHeaders() {
    return this.authorizationCodeRequestHeadersFactoryService.createHeaders();
  }

  createOptions() {
    const headers = this.createHeaders();
    return {
      headers: headers,
      addInstanceIdHeader: false,
      addFeatureTrackingHeaders: false,
      addSuperBatmanHeader: this.addSuperBatmanHeader
    };
  }
}
